import { render, staticRenderFns } from "./TheEmployeeTableSumsFooter.vue?vue&type=template&id=5d189a9e&scoped=true&"
import script from "./TheEmployeeTableSumsFooter.vue?vue&type=script&lang=js&"
export * from "./TheEmployeeTableSumsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d189a9e",
  null
  
)

export default component.exports